import React from 'react';
import useUser from '../hooks/useUser';
import ServerViewAssignedProduct from './server/ViewAssignedProduct';
import ClientViewAssignedProduct from './client/ViewAssignedProduct';

const ViewAssignedProduct = () => {
    const { userRole } = useUser();
    const role = userRole || localStorage.getItem('role') || '';
    const roleLower = role?.toLowerCase() || '';
    if (roleLower === 'client') {
        return <ClientViewAssignedProduct />;
    }
    return <ServerViewAssignedProduct />;
};

export default ViewAssignedProduct;
